var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowRightFilled(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.403076,
    width: 16,
    height: 16,
    rx: 8,
    fill: "#7953D2",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8669 8.92601C13.0444 8.75555 13.0444 8.47918 12.8669 8.30872L9.97416 5.53092C9.79665 5.36046 9.50884 5.36046 9.33133 5.53092C9.15382 5.70138 9.15382 5.97775 9.33133 6.14821L11.4481 8.18087L3.45455 8.18087C3.20351 8.18087 3 8.3763 3 8.61736C3 8.85843 3.20351 9.05385 3.45455 9.05385L11.4481 9.05385L9.33133 11.0865C9.15382 11.257 9.15382 11.5333 9.33133 11.7038C9.50884 11.8743 9.79665 11.8743 9.97416 11.7038L12.8669 8.92601Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightFilled);
export default __webpack_public_path__ + "static/media/arrow_right_filled.e04ae8468407867cf0164395c16325ac.svg";
export { ForwardRef as ReactComponent };